var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upload-wrapper"},[_vm._t("default"),_c('input',_vm._b({ref:"input",staticClass:"upload-wrapper__input",attrs:{"type":"file","accept":_vm.accept,"disabled":_vm.disabled},on:{"change":_vm.onChange}},'input',_vm.$attrs,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }